import { CanvasSizeModel } from './canvas-size.model';

export const CanvasSizeOriginal = new CanvasSizeModel('Don\'t Resize', -1, -1);
export const CanvasSizeMobile = new CanvasSizeModel('Common (Mobile)', 360, 640);
export const CanvasSizeCommon300x300 = new CanvasSizeModel('Common (Minimum)', 300, 300);
export const CanvasSizeCommon700x550 = new CanvasSizeModel('Common (Publish Default)', 700, 550);
export const CanvasSizeIPhoneX = new CanvasSizeModel('iPhone X', 375, 812);
export const CanvasSizeCommonTabletPortrait = new CanvasSizeModel('iPad (Portrait)', 768, 1024);
export const CanvasSizeCommonTabletLandscape = new CanvasSizeModel('iPad (Landscape)', 1024, 768);

export const CanvasSizes = [
    CanvasSizeOriginal,
    CanvasSizeMobile,
    CanvasSizeCommon700x550,
    CanvasSizeCommon300x300,
    CanvasSizeIPhoneX,
    CanvasSizeCommonTabletPortrait,
    CanvasSizeCommonTabletLandscape
];
